import React from "react";
import { motion } from "framer-motion";
import styles from "./Molly.module.css";
import mollyImage from "../../assets/molly.jpg";

const LoveCard = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={styles.container}
    >
      <div className={styles.card}>
        <motion.div
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className={styles.imageWrapper}
        >
          <img src={mollyImage} alt="Molly" className={styles.image} />
        </motion.div>

        <div className={styles.content}>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            className={styles.title}
          >
            To My Lovely Molly 💕
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
            className={styles.message}
          >
            Every moment with you feels like a page from the sweetest love
            story. You brighten my days, inspire my dreams, and make my heart
            dance. This card is just a little reminder of how special you are to
            me. 💖
          </motion.p>

          <motion.button
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 1, type: "spring", stiffness: 200 }}
            className={styles.button}
          >
            ❤️ Forever Yours
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default LoveCard;
